import { useSelector, useDispatch } from 'react-redux';
import { setDark, setTheme, setLang } from '../store/actions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const Settings = ({ dict, setDict, translations, setState }) => {
	const { theme, lang, dark } = useSelector((state) => state);
	const dispatch = useDispatch();
	var move = lang === 'rus' ? '7.8rem' : '.3rem';

	const handleCheck = (e) => {
		dispatch(setDark(!dark));
		localStorage.setItem('dark', !dark);
	}

	const handleLanguage = (lang) => {
		dispatch(setLang(lang));
		localStorage.setItem('lang', lang);
		switch (lang) {
			case 'rus':
				setDict(translations.rus);
				break
			case 'eng':
				setDict(translations.eng);
				break
			default:
				setDict(translations.rus);
				break
		}
	}

	const handleTheme = (theme) => {
		dispatch(setTheme(theme));
		localStorage.setItem('indtheme', theme);
	}

	return (
		<div className="settings">
			<div class="exitbtn" onClick={() => setState('home')}>
				<FontAwesomeIcon icon={faArrowLeft} className="exitbtn__icon" />
			</div>
			<div className='settings__category'>
				<div className="settings__category__header">{dict.settings.categories.appearance}</div>
				<label className="settings__category__entry">
					<div className="settings__category__entry__text">{dict.settings.options.darkmode.header}</div>
					<div className="settings__category__entry__switch">
						<input type='checkbox' className="setting__category__entry__switch__input" onChange={handleCheck} defaultChecked={dark} />
						<span className="settings__category__entry__switch__slider" />
					</div>
				</label>
				<div className="settings__category__entry" id="colorscheme">
					<label className={`settings__category__entry__option ${theme === 'bluish' ? 'sel' : ''}`} onClick={() => handleTheme('bluish')}>
						<div className="color_sircle">
							<div className="color_sircle__color" style={{ background: '#00b3e8' }}></div>
							<div className="color_sircle__color" style={{ background: '#59cfff' }}></div>
							<div className="color_sircle__color" style={{ background: '#c19fbf' }}></div>
						</div>
					</label>
					<label className={`settings__category__entry__option ${theme === 'darkfrst' ? 'sel' : ''}`} onClick={() => handleTheme('darkfrst')}>
						<div className="color_sircle">
							<div className="color_sircle__color" style={{ background: '#878c8c' }}></div>
							<div className="color_sircle__color" style={{ background: '#d2d3d3' }}></div>
							<div className="color_sircle__color" style={{ background: '#acadad' }}></div>
						</div>
					</label>
					<label className={`settings__category__entry__option ${theme === 'grasso' ? 'sel' : ''}`} onClick={() => handleTheme('grasso')}>
						<div className="color_sircle">
							<div className="color_sircle__color" style={{ background: '#00d434' }}></div>
							<div className="color_sircle__color" style={{ background: '#a9ffa8' }}></div>
							<div className="color_sircle__color" style={{ background: '#a3cbde' }}></div>
						</div>
					</label>
					<label className={`settings__category__entry__option ${theme === 'solize' ? 'sel' : ''}`} onClick={() => handleTheme('solize')}>
						<div className="color_sircle">
							<div className="color_sircle__color" style={{ background: '#92b991' }}></div>
							<div className="color_sircle__color" style={{ background: '#bde8fb' }}></div>
							<div className="color_sircle__color" style={{ background: '#a3cbde' }}></div>
						</div>
					</label>
					<label className={`settings__category__entry__option ${theme === 'purish' ? 'sel' : ''}`} onClick={() => handleTheme('purish')}>
						<div className="color_sircle">
							<div className="color_sircle__color" style={{ background: '#8b45ff' }}></div>
							<div className="color_sircle__color" style={{ background: '#a78eff' }}></div>
							<div className="color_sircle__color" style={{ background: '#c79eb8' }}></div>
						</div>
					</label>
					<label className={`settings__category__entry__option ${theme === 'bldy' ? 'sel' : ''}`} onClick={() => handleTheme('bldy')}>
						<div className="color_sircle">
							<div className="color_sircle__color" style={{ background: '#ff3740' }}></div>
							<div className="color_sircle__color" style={{ background: '#ff8a7e' }}></div>
							<div className="color_sircle__color" style={{ background: '#b2b485' }}></div>
						</div>
					</label>
					<label className={`settings__category__entry__option ${theme === 'dune' ? 'sel' : ''}`} onClick={() => handleTheme('dune')}>
						<div className="color_sircle">
							<div className="color_sircle__color" style={{ background: '#7d4a00' }}></div>
							<div className="color_sircle__color" style={{ background: '#ffce96' }}></div>
							<div className="color_sircle__color" style={{ background: '#9bb799' }}></div>
						</div>
					</label>
				</div>
			</div>
			<div className='settings__category'>
				<div className='settings__category__header'>{dict.settings.categories.language}</div>
				<div className='settings__category__entry' id="lang">
					<div className='settings__category__entry__text'>{dict.settings.options.language.header}</div>
					<div className='settings__category__entry__options'>
						<span className='settings__category__entry__options__selector' style={{
							left: move
						}} />
						<label className={`settings__category__entry__options__entry ${lang === 'eng' ? 'sel' : ''}`} onClick={() => handleLanguage('eng')}>{dict.settings.options.language.eng}</label>
						<label className={`settings__category__entry__options__entry ${lang === 'rus' ? 'sel' : ''}`} onClick={() => handleLanguage('rus')}>{dict.settings.options.language.rus}</label>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Settings;
